export default {"src":"/_next/static/media/string.c76f7db3.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};